import type { AxiosResponse } from 'axios';

/** FlowGate echo한 X-Request-Id 추출. axios 자동 소문자화 대응 (D-02 §6.6). */
export function extractRequestId(res: AxiosResponse): string | null {
  return (res.headers['x-request-id'] as string | undefined) ?? null;
}
